import { PATHS } from '../const/paths.constants';
import { IAssignPayload, IBooking } from '../interfaces/booking.interface';
import { API as API_BACKEND } from './config-backend.api';
import { API as API_DASHBACK } from './config-dashback.api';

import { API as API_SERVICE } from './config-service.api';

export const getBooking = async (id: string): Promise<IBooking> => {
    const url = `/booking/getBookingDetails?id=${id}`;
    const response = await API_BACKEND.get<IBooking>(url);
    return response.data;
};

export const getBookings = (queryParams: any) => {
    const urlParams = new URLSearchParams(queryParams);
    return API_DASHBACK.get(`/delivery-partner/getBookings?${urlParams.toString()}`);
};

export const getMiniBookings = (queryParams: any) => {
    const urlParams = new URLSearchParams(queryParams);
    return API_DASHBACK.get(`/delivery-partner/mini-bookings?${urlParams.toString()}`);
};

export const getBookingEvents = (id: string) => API_DASHBACK.get(`/bookings/${id}/events`);

export const unassignDriver = (id: string, driverID: string) => API_DASHBACK.post(`delivery-partner/bookings/${id}/unassign-driver`, { driverID });

export const manualAssignDriver = (payload: IAssignPayload) => {
    const {
        bookingID,
        driverID,
        token,
        driverTag,
    } = payload;

    const Authorization = `Bearer ${token}`;
    const url = `${PATHS.BOOKINGS}/${bookingID}/manual-assign-driver/${driverID}`;

    return API_SERVICE.post(url, { driverTag }, { headers: { Authorization } });
};
